import setting from './setting'
import gateway from './gateway'
import url from './url'
import dictionary from './dictionary/index'
import fileManager from './file-manager'
import appVersion from './app-version'
import operation from './operation'
import codeGenerate from './code-generate'
import webView from './web-view'
import webService from './web-service'
import attachment from './attachment'

export default {
  name: 'System',
  path: 'system',
  meta: {
    label: 'system',
    auth: 'system'
  },
  component: {
    name: 'System',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    setting,
    gateway,
    url,
    dictionary,
    fileManager,
    appVersion,
    operation,
    codeGenerate,
    webView,
    webService,
    attachment
  ]
}
